import { ArretSlbTLR } from '../../arret-slb/entities/arret-slb-tlr.entity';

export class AssociationArretsOrder {
	constructor(
		public accesId: number,
		public arrets: ArretSlbTLR[],
		public commentaireArrets: string,
		public shouldSignalAbsenceArret: boolean,
	) {
	}
}